import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import { INCOMING_INVOICE_STATE_COLOR } from "@msuite/utils/incoming-invoices";
import type { Enums } from "@msuite/utils/types";

/** Props Interface */
interface IncomingInvoiceStateTagProps {
	state: Enums<"incomingInvoiceState">;
}

export function IncomingInvoiceStateTag({ state }: IncomingInvoiceStateTagProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Tag
			size="xs"
			color={INCOMING_INVOICE_STATE_COLOR[state]}
			variant="plain"
		>
			{t(`incoming_invoices.state.${state}`)}
		</Tag>
	);
}
